export const dataFormType = {
    input: 'input',
    radio: 'radio',
    select: 'select',
    textarea: 'textarea'
}
